import { ref } from 'vue';
import config from '~/config';
import ayahHeader from '~/components/ayahPage/ayahHeader.vue';
import toolFacet from '~/components/ayahPage/toolFacet.vue';
import toolData from '~/components/ayahPage/toolData.vue';
import analysisData from '~/components/ayahPage/analysisData.vue';
import bookFilter from '~/components/ayahPage/bookFilter.vue';
import lazyLoad from '~/components/Shared/lazyLoad.vue'
import loading from '~/components/Shared/loading.vue'
import tab from '~/components/Shared/tab.vue';
import relatedAyahDocument from '~/components/ayahPage/relatedAyahDocument.vue';
import qamusSearch from '~/components/ayahPage/qamusSearch.vue';
import { mapStores } from 'pinia';
import { useAyahStore } from '~/stores/ayah'
import { useQuranStore } from '~/stores/quran'
import { useWebsiteStore } from '~/stores/website'
import { useTranslateStore } from '~/stores/translate'
import { useCommentaryStore } from '~/stores/commentary'
import { useHadithStore } from '~/stores/hadith'
import { useGlobalStore } from '~/stores/global'
import { useDropdownStore } from '~/stores/dropdown';
import { useSurahStore } from "~/stores/surah";
import { useTextSelection } from '@vueuse/core';
import { useWindowSize } from '@vueuse/core';

export default {
    components: { ayahHeader, toolFacet, toolData, analysisData, bookFilter, tab, lazyLoad, loading, relatedAyahDocument, qamusSearch },
    computed: {
        ...mapStores(useAyahStore),
        ...mapStores(useQuranStore),
        ...mapStores(useWebsiteStore),
        ...mapStores(useTranslateStore),
        ...mapStores(useCommentaryStore),
        ...mapStores(useHadithStore),
        ...mapStores(useGlobalStore),
        ...mapStores(useSurahStore),

        isMobile() {
            return this.globalStore.isMobile
        },
        showBookFilter() {
            const useCase = this.activeTab
            const bookFilterTabs = ['translate', 'commentary', 'related_hadith']
            return bookFilterTabs.includes(useCase)
        },
        showFoundResults() {
            const useCase = this.activeTab
            const noFoundResultTabs = ['related_vocabulary', 'analysis']
            return !noFoundResultTabs.includes(useCase)
        },
        facetContainSearch() {
            // const useCase = this.activeTab
            // return useCase === "related_library" ? true : false
            return true;
        }
    },
    data() {
        return {
            activeQari: 9,
            activeOrthography: 4,
            showBookFilterComponent: false,
            audioObject: {},
            audioSource: '',
            isAyahContaienrFullScreen: false,
            tabData: ["translate", "commentary", "related_hadith", "related_vocabulary", "related_propername", "related_subject", "analysis", "related_ayah", "related_library"],
            facetDataForMobile: {},
            bookFilterData: [],
            relatedAyahDocumentsData: []
        }
    },
    async setup() {
        const route = useRoute()
        const router = useRouter()
        const { t, locale } = useI18n()
        const endOfListData = ref(0)
        endOfListData.value = false
        const isAyahListLoaded = ref(0)
        const isListDataLoaded = ref(0)
        const activeAyah = useState('ayah-ayah', () => 0);
        const activeTab = useState('ayah-tab', () => 0);
        const activeSurah = useState('ayah-surah', () => 0);
        const AyahListOfSurah = ref(0)
        const listData = ref(0)
        const analysisData = ref(0)
        const order = ref(0)
        const offset = ref(0)
        const orthographyId = ref(0)
        const activeOptionFromFacet = ref(0)
        const facetData = ref(0)
        const totalCountOfResult = ref(0)
        const orderList = ref(0)
        const playerCurrAyah = ref(0)
        const selectedAyahObj = ref()
        const selectedSurahObj = ref()
        const activeQari = ref()

        const selection = useTextSelection();
        const { width } = useWindowSize();
        const showSearchOptions = ref(false);

        const ayahBox = ref(null);

        const isSelectionInAyahBox = computed(() => {
            if (import.meta.client) {
                const c = ayahBox.value?.getBoundingClientRect(); // Container Geometry
                const s = selection.rects.value?.[0] // Selected Text Geometry
                return (c?.left <= s?.left && c?.right >= s?.right && c?.top <= s?.top && c?.bottom >= s?.bottom);
            }
            return false;
        });

        const showQamusModal = ref(false);

        watch(selection.text, (v) => {
            v.length ? {} : showSearchOptions.value = false;
        });

        // useHead({
        //     title: t('encyclopedia') + t('title_seprator') + t('title'),
        // })

        const selectedOrthographyCookie = useCookie('selectedOrthography', {
            default: () => 4, // Default value if the cookie doesn't exist
        });
        orthographyId.value = selectedOrthographyCookie.value;

        const selectedRecitorCookie = useCookie('selectedRecitor', {
            default: () => 9, // Default value if the cookie doesn't exist
        });
        activeQari.value = selectedRecitorCookie.value;

        const dropdownStore = useDropdownStore();

        const ayahChangedTrigger = (item) => {
            dropdownStore.setMessage(item);
        };

        order.value = 0
        activeOptionFromFacet.value = []
        AyahListOfSurah.value = []
        // activeAyah.value = route.query.ayahNum
        // activeTab.value = route.query.useCase
        // activeSurah.value = route.query.surah
        activeAyah.value = route.params.slug[1] ?? 1
        activeTab.value = route.params.slug[2] ?? "translate"
        activeSurah.value = route.params.slug[0] ?? 1
        playerCurrAyah.value = activeAyah.value;

        const ayahStore = useAyahStore()
        const surahStore = useSurahStore()

        function replaceSlug() {
            if (import.meta.client) {
                history.replaceState({}, '', `/${locale.value}/ayah/${activeSurah.value}/${activeAyah.value}/${activeTab.value}`);
            }
        }

        const init = () => {
            replaceSlug();
        }

        const getAyahListOfSurah = async () => {
            const params = {
                surahId: activeSurah.value,
                orthographyId: orthographyId.value
            }
            // AyahListOfSurah.value = await ayahStore.getAyahListOfSurah(params)
            await ayahStore.getAyahListOfSurah(params).then((response) => {
                isAyahListLoaded.value = true

                AyahListOfSurah.value = response;

                selectedAyahObj.value = AyahListOfSurah.value?.filter((a, i) => {
                    return a.SurahId === parseInt(activeSurah.value) && a.AyahNum === parseInt(activeAyah.value);
                })[0]
            })

        }
        const handleTabData = async (isFreshData, tabName = activeTab.value) => {
            endOfListData.value = false
            activeTab.value = tabName
            replaceSlug();
            setOrderList(tabName)

            await surahStore.getSurahList({
                language: locale.value,
            }).then((response) => {
                selectedSurahObj.value = response.filter((a, i) => {
                    return a.Id === parseInt(activeSurah.value)
                })[0]
            });

            switch (tabName) {
                case 'translate':
                    await getTranslateList(isFreshData);

                    useHead({
                        title: `${removeHtmlTags(selectedAyahObj.value.Text)} - ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}`, //t('encyclopedia') + t('title_seprator') + t('title'),
                        meta: [
                            { name: 'description', content:  listData.value[0]?.discreiption},
                            { name: 'keywords', content: `${t('translate')} ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}, ${listData.value[0]?.title} , ${removeHtmlTags(selectedAyahObj.value.Text,true)}` }
                          ]
                    })

                    break;
                case 'commentary':
                    await getCommentaryList(isFreshData)

                    useHead({
                        title: `${t('commentary')} ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}`, //t('encyclopedia') + t('title_seprator') + t('title'),
                        meta: [
                            { name: 'description', content:  listData.value[0]?.discreiption},
                            { name: 'keywords', content: `${t('commentary')} ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}, ${listData.value[0]?.title} , ${removeHtmlTags(selectedAyahObj.value.Text,true)}` }
                          ]
                    })

                    break;
                case 'related_hadith':
                    await getRelatedHadithList(isFreshData)

                    useHead({
                        title: `${t('related_hadith')} ${removeHtmlTags(selectedAyahObj.value.Text)}`, //t('encyclopedia') + t('title_seprator') + t('title'),
                        meta: [
                            { name: 'description', content:  listData.value[0]?.discreiption},
                            { name: 'keywords', content: `${t('related_hadith')} ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}, ${listData.value[0]?.title} , ${removeHtmlTags(selectedAyahObj.value.Text,true)}` }
                          ]
                    })

                    break;
                case 'related_vocabulary':
                    await getRelatedVocabularyList(isFreshData)

                    useHead({
                        title: `${t('related_vocabulary')} ${removeHtmlTags(selectedAyahObj.value.Text)}`, //t('encyclopedia') + t('title_seprator') + t('title'),
                        meta: [
                            { name: 'description', content:  listData.value[0]?.discreiption},
                            { name: 'keywords', content: `${t('related_vocabulary')} ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}, ${listData.value[0]?.title} , ${removeHtmlTags(selectedAyahObj.value.Text,true)}` }
                          ]
                    })

                    break;
                case 'related_propername':
                    await getRelatedProperNameList(isFreshData)

                    useHead({
                        title: `${t('related_propername')} ${removeHtmlTags(selectedAyahObj.value.Text)}`, //t('encyclopedia') + t('title_seprator') + t('title'),
                        meta: [
                            { name: 'description', content:  listData.value[0]?.discreiption},
                            { name: 'keywords', content: `${t('related_propername')} ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}, ${listData.value[0]?.title} , ${removeHtmlTags(selectedAyahObj.value.Text,true)}` }
                          ]
                    })

                    break;
                case 'related_subject':
                    await getRelatedSubjectList(isFreshData);

                    useHead({
                        title: `${t('related_subject')} ${removeHtmlTags(selectedAyahObj.value.Text)}`,  //t('encyclopedia') + t('title_seprator') + t('title'),
                        meta: [
                            { name: 'description', content:  listData.value[0]?.discreiption},
                            { name: 'keywords', content: `${t('related_subject')} ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}, ${listData.value[0]?.title} , ${removeHtmlTags(selectedAyahObj.value.Text,true)}` }
                          ]
                    })

                    break;
                case 'analysis':
                    await getAnalysis(isFreshData)

                    useHead({
                        title: `${t('analysis')} ${removeHtmlTags(selectedAyahObj.value.Text)}`, //t('encyclopedia') + t('title_seprator') + t('title'),
                        meta: [
                            { name: 'description', content:  listData.value[0]?.discreiption},
                            { name: 'keywords', content: `${t('analysis')} ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}, ${listData.value[0]?.title} , ${removeHtmlTags(selectedAyahObj.value.Text,true)}` }
                          ]
                    })

                    break;
                case 'related_ayah':
                    await getRelatedAyahList(isFreshData)

                    useHead({
                        title: `${t('related_ayah')} ${removeHtmlTags(selectedAyahObj.value.Text)}`, //t('encyclopedia') + t('title_seprator') + t('title'),
                        meta: [
                            { name: 'description', content:  listData.value[0]?.discreiption},
                            { name: 'keywords', content: `${t('related_ayah')} ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}, ${listData.value[0]?.title} , ${removeHtmlTags(selectedAyahObj.value.Text,true)}` }
                          ]
                    })

                    break;
                case 'related_library':
                    await getRelatedLibraryList(isFreshData)

                    useHead({
                        title: `${t('related_library')} ${removeHtmlTags(selectedAyahObj.value.Text)}`, //t('encyclopedia') + t('title_seprator') + t('title'),
                        meta: [
                            { name: 'description', content:  listData.value[0]?.discreiption[0]?.Text},
                            { name: 'keywords', content: `${t('related_library')} ${t('ayah')} ${selectedAyahObj.value.AyahNum} ${t('surah')} ${selectedSurahObj.value.Title}, ${listData.value[0]?.title} , ${removeHtmlTags(selectedAyahObj.value.Text,true)}` }
                          ]
                    })

                    break;
                // default:
                //     await getTranslateList();
            }
        }
        const setOrderList = tabName => {
            switch (tabName) {
                case 'translate':
                case 'commentary':
                    orderList.value = [
                        {
                            name: 'default',
                            number: 0
                        },
                        {
                            name: 'century',
                            number: 1
                        }
                    ]
                    break;
                case 'related_ayah':
                    orderList.value = [
                        {
                            name: 'connection',
                            number: 0
                        },
                        {
                            name: 'fallOrder',
                            number: 1
                        }
                    ]
                    break;
                case 'related_library':
                    orderList.value = [
                        {
                            name: 'default',
                            number: 0
                        },
                        {
                            name: 'date',
                            number: 1
                        },
                        {
                            name: 'alphabet',
                            number: 2
                        }
                    ]
                    break;
                default:
                    orderList.value = []
                    break;
            }
        }
        const getTranslateList = async (isFreshData) => {
            isListDataLoaded.value = false

            if (isFreshData) {
                offset.value = 1
            }

            const params = {
                ayahNumber: activeAyah.value,
                language: locale.value,
                pageNumber: offset.value,
                pageSize: 30,
                surahId: activeSurah.value,
                order: order.value,
                bookIds: '',
                languageIds: '',
                religionIds: '',
                translateTypeIds: ''
            }
            for (const item of activeOptionFromFacet.value) {
                if (item.parentTitle === 'book')
                    params.bookIds += `${item.id},`
                if (item.parentTitle === 'type')
                    params.translateTypeIds += `${item.id},`
                if (item.parentTitle === 'language')
                    params.languageIds += `${item.id},`
                if (item.parentTitle === 'religion')
                    params.religionIds += `${item.id},`
            }
            const translateList = await ayahStore.getTranslateList(params)
            if (offset.value == 1)
                totalCountOfResult.value = translateList?.ResultSet1[0]?.ResultCount ?? 0
            if (translateList?.ResultSet1?.length) {
                prepareDataForToolDataComponent(translateList.ResultSet1, isFreshData, 'translate')
                prepareDataForFacetDataComponent(translateList.ResultSet2, 'translate')
            } else {
                if (isFreshData) {
                    listData.value = []
                    facetData.value = []
                }
                endOfListData.value = true
            }

            isListDataLoaded.value = true
        }
        const getCommentaryList = async isFreshData => {
            isListDataLoaded.value = false

            if (isFreshData) {
                offset.value = 1
            }

            const params = {
                ayahNumber: activeAyah.value,
                order: order.value,
                pageNumber: offset.value,
                pageSize: 30,
                surahId: activeSurah.value,
                language: locale.value,
                authorIds: '',
                bookIds: '',
                centuryIds: '',
                commentaryTypeIds: '',
                languageIds: '',
                religionIds: '',
            }
            for (const item of activeOptionFromFacet.value) {
                if (item.parentTitle === 'author')
                    params.authorIds += `${item.id},`
                if (item.parentTitle === 'book')
                    params.bookIds += `${item.id},`
                if (item.parentTitle === 'century')
                    params.centuryIds += `${item.id},`
                if (item.parentTitle === 'type')
                    params.commentaryTypeIds += `${item.id},`
                if (item.parentTitle === 'language')
                    params.languageIds += `${item.id},`
                if (item.parentTitle === 'religion')
                    params.religionIds += `${item.id},`
            }
            const commentaryList = await ayahStore.getCommentaryList(params)
            if (offset.value == 1)
                totalCountOfResult.value = commentaryList?.ResultSet1[0]?.ResultCount ?? 0
            if (commentaryList?.ResultSet1?.length) {
                prepareDataForToolDataComponent(commentaryList.ResultSet1, isFreshData, 'commentary')
                prepareDataForFacetDataComponent(commentaryList.ResultSet2, 'commentary')
            } else {
                if (isFreshData) {
                    listData.value = []
                    facetData.value = []
                }
                endOfListData.value = true
            }
            isListDataLoaded.value = true
        }

        const getRelatedHadithList = async (isFreshData) => {
            isListDataLoaded.value = false

            if (isFreshData) {
                offset.value = 1
            }
            const params = {
                ayahNumber: activeAyah.value,
                order: order.value,
                pageNumber: offset.value,
                pageSize: 30,
                surahId: activeSurah.value,
                language: locale.value,
                bookIds: '',
                centuryIds: '',
                hadithTypeId: '',
                religionIds: '',
            }
            for (const item of activeOptionFromFacet.value) {
                if (item.parentTitle === 'book')
                    params.bookIds += `${item.id},`
                if (item.parentTitle === 'century')
                    params.centuryIds += `${item.id},`
                if (item.parentTitle === 'type')
                    params.hadithTypeId += `${item.id},`
                if (item.parentTitle === 'religion')
                    params.religionIds += `${item.id},`
            }
            const relatedHadithList = await ayahStore.getRelatedHadithList(params)
            if (offset.value == 1)
                totalCountOfResult.value = relatedHadithList?.ResultSet1[0]?.ResultCount ?? 0
            if (relatedHadithList?.ResultSet1?.length) {
                prepareDataForToolDataComponent(relatedHadithList.ResultSet1, isFreshData, 'relatedHadith')
                prepareDataForFacetDataComponent(relatedHadithList.ResultSet2, 'relatedHadith')
            } else {
                if (isFreshData) {
                    listData.value = []
                    facetData.value = []
                }
                endOfListData.value = true
            }
            isListDataLoaded.value = true
        }

        const getRelatedVocabularyList = async (isFreshData) => {
            isListDataLoaded.value = false
            if (isFreshData) {
                offset.value = 1
            }
            const params = {
                ayahNumber: activeAyah.value,
                surahId: activeSurah.value,
                language: locale.value,
                orthographyId: orthographyId.value,
                languageId: 0,
                definitionId: 0,
                translationId: 0,
                wordId: 0,
            }
            for (const item of activeOptionFromFacet.value) {
                if (item.parentTitle === 'book')
                    params.definitionId = `${item.id}`
                if (item.parentTitle === 'word')
                    params.wordId = `${item.id}`
                if (item.parentTitle === 'language')
                    params.languageId = `${item.id}`
            }
            const relatedVocabularyList = await ayahStore.getRelatedVocabularyList(params)
            totalCountOfResult.value = relatedVocabularyList?.DataList[0]?.ResultCount ?? 0
            if (relatedVocabularyList?.DataList?.length) {
                prepareDataForToolDataComponent(relatedVocabularyList.DataList, isFreshData, 'relatedVocabulary')
                prepareDataForFacetDataComponent(relatedVocabularyList.FacetList, 'relatedVocabulary')
            } else {
                if (isFreshData) {
                    listData.value = []
                    facetData.value = []
                }
            }
            endOfListData.value = true
            isListDataLoaded.value = true
        }

        const getRelatedProperNameList = async isFreshData => {
            isListDataLoaded.value = false

            if (isFreshData) {
                offset.value = 1
            }

            const params = {
                ayahNumber: activeAyah.value,
                order: order.value,
                pageNumber: offset.value,
                pageSize: 30,
                surahId: activeSurah.value,
                language: locale.value,
                propernameGroupIds: '',
            }
            for (const item of activeOptionFromFacet.value) {
                if (item.parentTitle === 'type')
                    params.propernameGroupIds += `${item.id},`
            }
            const relatedProperNameList = await ayahStore.getRelatedProperNameList(params)
            if (offset.value == 1)
                totalCountOfResult.value = relatedProperNameList?.ResultSet1[0]?.ResultCount ?? 0
            if (relatedProperNameList?.ResultSet1?.length) {
                prepareDataForToolDataComponent(relatedProperNameList.ResultSet1, isFreshData, 'relatedProper')
                prepareDataForFacetDataComponent(relatedProperNameList.ResultSet2, 'relatedProper')
            } else {
                if (isFreshData) {
                    listData.value = []
                    facetData.value = []
                }
                endOfListData.value = true
            }
            isListDataLoaded.value = true
        }

        const getRelatedSubjectList = async isFreshData => {
            isListDataLoaded.value = false

            if (isFreshData) {
                offset.value = 1
            }

            const params = {
                ayahNumber: activeAyah.value,
                order: order.value,
                pageNumber: offset.value,
                pageSize: 30,
                surahId: activeSurah.value,
                language: locale.value,
                languages: '',
                subjectGroupPathOrders: ''
            }
            for (const item of activeOptionFromFacet.value) {
                if (item.parentTitle === 'subjectgroup')
                    params.subjectGroupPathOrders = `${item.id}`
                if (item.parentTitle === 'language')
                    params.languages = `${item.id}`
            }
            const relatedSubjectList = await ayahStore.getRelatedSubjectList(params)
            if (offset.value == 1)
                totalCountOfResult.value = relatedSubjectList?.ResultSet1[0]?.ResultCount ?? 0
            if (relatedSubjectList?.ResultSet1?.length) {
                prepareDataForToolDataComponent(relatedSubjectList.ResultSet1, isFreshData, 'relatedSubject')
                prepareDataForFacetDataComponent(relatedSubjectList.ResultSet2, 'relatedSubject')
            } else {
                if (isFreshData) {
                    listData.value = []
                    facetData.value = []
                }
                endOfListData.value = true
            }
            isListDataLoaded.value = true
        }

        const getRelatedAyahList = async isFreshData => {
            isListDataLoaded.value = false

            if (isFreshData) {
                offset.value = 1
            }

            const params = {
                ayahNumber: activeAyah.value,
                order: order.value,
                pageNumber: offset.value,
                pageSize: 30,
                surahId: activeSurah.value,
                language: locale.value,
                bookIds: '',
                fallPlaceIds: '',
                relatedAyahTypeId: 0,
                surahIds: ''
            }
            for (const item of activeOptionFromFacet.value) {
                if (item.parentTitle === 'place')
                    params.fallPlaceIds = `${item.id}`
                if (item.parentTitle === 'type')
                    params.relatedAyahTypeId = `${item.id}`
                if (item.parentTitle === 'surah')
                    params.surahIds = `${item.id}`
            }
            const relatedAyahList = await ayahStore.getRelatedAyahList(params)
            if (offset.value == 1)
                totalCountOfResult.value = relatedAyahList?.ResultSet1[0]?.ResultCount ?? 0
            if (relatedAyahList?.ResultSet1?.length) {
                prepareDataForToolDataComponent(relatedAyahList.ResultSet1, isFreshData, 'relatedAyah')
                prepareDataForFacetDataComponent(relatedAyahList.ResultSet2, 'relatedAyah')
            } else {
                if (isFreshData) {
                    listData.value = []
                    facetData.value = []
                }
                endOfListData.value = true
            }
            isListDataLoaded.value = true
        }

        const getRelatedLibraryList = async isFreshData => {
            isListDataLoaded.value = false

            if (isFreshData) {
                offset.value = 1
            }

            const params = {
                ayahNumber: activeAyah.value,
                order: order.value,
                pageNumber: offset.value,
                pageSize: 30,
                surahId: activeSurah.value,
                books: '',
                creators: '',
                languages: '',
                publishers: '',
                subjects: '',
                sort: order.value
            }
            for (const item of activeOptionFromFacet.value) {
                if (item.parentTitle === 'books')
                    params.books = `${item.id}`
                if (item.parentTitle === 'publisher')
                    params.publishers = `${item.id}`
                if (item.parentTitle === 'creator')
                    params.creators += `${item.id},`
                if (item.parentTitle === 'language')
                    params.languages += `${item.id},`
                if (item.parentTitle === 'subject')
                    params.subjects += `${item.id},`
            }
            const relatedLibraryList = await ayahStore.getRelatedLibraryList(params)
            if (offset.value == 1)
                totalCountOfResult.value = relatedLibraryList?.totalCount ?? 0
            if (relatedLibraryList?.results?.length) {
                prepareDataForToolDataComponent(relatedLibraryList.results, isFreshData, 'relatedLibrary')
                prepareDataForFacetDataComponent(relatedLibraryList.facets, 'relatedLibrary')
            } else {
                if (isFreshData) {
                    listData.value = []
                    facetData.value = []
                }
                endOfListData.value = true
            }
            isListDataLoaded.value = true
        }

        const getAnalysis = async isFreshData => {
            isListDataLoaded.value = false

            const params = {
                ayahNumber: activeAyah.value,
                surahId: activeSurah.value,
            }

            var analysisListP1 = undefined
            var analysisListP2 = undefined

            analysisListP1 = await ayahStore.getAnalysisListP1(params);
            analysisListP2 = await ayahStore.getAnalysisListP2(params);

            prepareDataForFacetDataComponent([], 'analysis')
            analysisData.value = { ...analysisListP1, relatedRhetoric: analysisListP2 }

            endOfListData.value = true
            isListDataLoaded.value = true
        }

        const prepareDataForToolDataComponent = (list, isFreshData, tabName) => {
            if (isFreshData)
                listData.value = []

            switch (tabName) {
                case 'translate':
                case 'commentary':
                    for (const object of list) {
                        const data = {
                            id: object.Id,
                            title: object.BookTitle,
                            discreiption: object.Text,
                            BookFromPage: object.BookFromPage,
                            NoorLibId: object.NoorlibId,
                            VolumeNumber: object.VolumeNumber,
                            BookTitle: object.AuthorFullName
                        }
                        listData.value.push(data)
                    }
                    break
                case 'relatedHadith':
                    for (const object of list) {
                        const data = {
                            id: object.Id,
                            title: object.bookTitle,
                            discreiption: object.Text,
                            hadithGroup: object.HadithGroup,
                            NoorHadithId: object.NoorHadithId,
                            BookFromPage: object.BookFromPage,
                            NoorLibId: object.NoorlibId,
                            VolumeNumber: object.VolumNumber,
                            BookTitle: object.AuthorFullName,
                            button: {
                                position: 'bottom',
                                title: t('other_sources')
                            }
                        }
                        listData.value.push(data)
                    }
                    break
                case 'relatedVocabulary':
                    for (const object of list) {
                        const data = {
                            id: object.Id,
                            title: object.CandidateTitle + (object.Roots !== undefined && object.Roots.length > 0 && object.Roots[0] !== 'فاقد ریشه' ? ` [ ${object.Roots[0].split('').join(' ')} ]` : ''),
                            subTitle: null,
                            discreiption: object.List[0]?.DataList,
                            enId: object.WordId
                        }
                        listData.value.push(data)
                    }
                    break
                case 'relatedProper':
                    for (const object of list) {
                        const data = {
                            id: object.Id,
                            superTitle: object.Word,
                            title: object.ProperNameTitle,
                            subTitle: t('group_type', { group: object.ProperNameGroupTitle, type: object.WordProperNameTypeTitle }),
                            discreiption: object.ProperNameAbout,
                            propernameId: object.ProperNameId,
                        }
                        listData.value.push(data)
                    }
                    break
                case 'relatedSubject':
                    for (const object of list) {
                        const data = {
                            id: object.Id,
                            title: object.Title,
                            subTitle: null,
                            discreiption: JSON.parse(object.SubjectPath)?.map(item => item.Title)?.join(' / '),
                        }
                        listData.value.push(data)
                    }
                    break
                case 'relatedAyah':

                    for (const object of list) {
                        const data = {
                            id: object.Id,
                            title: object.SurahTitle,
                            relatedAyahNumber: object.AyahNumber,
                            relatedSurahId: object.SurahId,
                            RelatedTypeTitle: object.RelatedTypeTitle,
                            Score: object.Score,
                            RelatedTypeId: object.RelatedTypeId,
                            discreiption: object.Text,
                            button: {
                                position: 'left',
                                title: t('documentation')
                            }
                        }
                        listData.value.push(data)
                    }
                    break

                case 'relatedLibrary':
                    for (const object of list) {
                        const data = {
                            id: object.id,
                            title: object.bookTitle,
                            discreiption: object.text?.map(string => { return { Text: string } }),
                            BookFromPage: object.pageNumber,
                            NoorLibId: object.bookId,
                            VolumeNumber: object.volumeNumber,
                            BookTitle: object.bookCreatorName
                        }
                        listData.value.push(data)
                    }
                    break
                default:
                    break;
            }
        }

        const prepareDataForFacetDataComponent = (list, tabName) => {
            switch (tabName) {
                case 'translate':
                case 'commentary':
                    facetData.value = []
                    for (const item of list) {
                        const typeInFacetData = facetData.value.find(object => object.title === item.ItemType)
                        const selected = activeOptionFromFacet.value.find(object => object.id == item.Id && object.parentTitle == item.ItemType) ? true : false
                        if (typeInFacetData) {
                            typeInFacetData.options.push({ id: item.Id, number: item.ItemCount, title: item.Title, order: item.ItemCount, selected })
                        } else {
                            facetData.value.push({ title: item.ItemType, options: [{ id: item.Id, number: item.ItemCount, title: item.Title, order: item.ItemCount, selected }] })
                        }
                    }
                    break;

                case 'relatedHadith':
                    facetData.value = []
                    for (const item of list) {
                        const typeInFacetData = facetData.value.find(object => object.title === item.ItemType)
                        const selected = activeOptionFromFacet.value.find(object => object.id == item.Id && object.parentTitle == item.ItemType) ? true : false
                        if (typeInFacetData) {
                            typeInFacetData.options.push({ id: item.Id, number: item.ItemCount, title: item.Title, order: item.ItemCount, selected })
                        } else {
                            facetData.value.push({ title: item.ItemType, options: [{ id: item.Id, number: item.ItemCount, title: item.Title, order: item.ItemCount, selected }] })
                        }
                    }
                    break;
                case 'relatedVocabulary':
                    facetData.value = []
                    for (const item of list) {
                        const typeInFacetData = facetData.value.find(object => object.title === item.ItemType)
                        const selected = activeOptionFromFacet.value.find(object => object.id == item.Id && object.parentTitle == item.ItemType) ? true : false
                        if (typeInFacetData) {
                            typeInFacetData.options.push({ id: item.Id, number: item.ItemCount, title: item.Title, order: item.ItemCount ?? null, selected })
                        } else {
                            facetData.value.push({ title: item.ItemType, options: [{ id: item.Id, number: item.ItemCount, title: item.Title, order: item.ItemCount ?? null, selected }] })
                        }
                    }
                    break;
                case 'relatedProper':
                    facetData.value = []
                    for (const item of list) {
                        const typeInFacetData = facetData.value.find(object => object.title === item.ItemType)
                        const selected = activeOptionFromFacet.value.find(object => object.id == item.Id && object.parentTitle == item.ItemType) ? true : false
                        if (typeInFacetData) {
                            typeInFacetData.options.push({ id: item.Id, number: item.ItemCount, title: item.Title, order: item.ItemCount ?? null, selected })
                        } else {
                            facetData.value.push({ title: item.ItemType, options: [{ id: item.Id, number: item.ItemCount, title: item.Title, order: item.ItemCount ?? null, selected }] })
                        }
                    }
                    break;
                case 'relatedSubject':
                    facetData.value = []
                    for (const item of list) {
                        const typeInFacetData = facetData.value.find(object => object.title === item.ItemType)
                        const selected = activeOptionFromFacet.value.find(object => object.id == item.Id && object.parentTitle == item.ItemType) ? true : false
                        if (typeInFacetData) {
                            typeInFacetData.options.push({ id: parseInt(item.Id), number: item.ItemCount, title: item.Title, order: item.ItemCount ?? null, selected })
                        } else {
                            facetData.value.push({ title: item.ItemType, options: [{ id: parseInt(item.Id), number: item.ItemCount, title: item.Title, order: item.ItemCount, selected }] })
                        }
                    }
                    break;
                case 'relatedAyah':
                    facetData.value = []
                    for (const item of list) {
                        const typeInFacetData = facetData.value.find(object => object.title === item.ItemType)
                        const selected = activeOptionFromFacet.value.find(object => object.id == item.Id && object.parentTitle == item.ItemType) ? true : false
                        if (typeInFacetData) {
                            typeInFacetData.options.push({ id: parseInt(item.Id), number: item.ItemCount, title: item.Title, order: item.ItemCount ?? null, selected })
                        } else {
                            facetData.value.push({ title: item.ItemType, options: [{ id: parseInt(item.Id), number: item.ItemCount, title: item.Title, order: item.ItemCount, selected }] })
                        }
                    }
                    break;
                case 'relatedLibrary':
                    facetData.value = []
                    for (const title in list) {
                        facetData.value.push({ title: title, options: list[title].map(object => { return { selected: activeOptionFromFacet.value.find(item => item.id == object.id && item.parentTitle == title) ? true : false, id: parseInt(object.id), number: object.count, title: object.title, order: object.count ?? null } }) })
                    }
                    break;
                case 'analysis':
                    facetData.value = []
                    break;
                default:
                    break;
            }
        }

        const getCommentarySingle = async (params) => {
            isListDataLoaded.value = false

            await ayahStore.getCommentarySingle(params).then((repoonse) => {
                params.item.FullText = repoonse.Text;
            })
            isListDataLoaded.value = true
        }

        const removeHtmlTags = (text,isRemoveErab = false) => {
            if(isRemoveErab){
                return text?.replace(/<[^>]*>/g, '').replace(/[\u064B-\u065F\u0670\u06D6-\u06ED]/g, '');
            }
            return text?.replace(/<[^>]*>/g, '');
        }

        init()
        await getAyahListOfSurah();
        await handleTabData(true);

        return {
            endOfListData,
            isListDataLoaded,
            isAyahListLoaded,
            activeAyah,
            activeTab,
            activeSurah,
            AyahListOfSurah,
            listData,
            analysisData,
            order,
            playerCurrAyah,
            offset,
            orthographyId,
            facetData,
            activeOptionFromFacet,
            handleTabData,
            getAyahListOfSurah,
            getCommentarySingle,
            totalCountOfResult,
            router,
            route,
            locale,
            orderList,
            replaceSlug,
            selectedAyahObj,
            selectedSurahObj,
            activeQari,
            ayahChangedTrigger,
            selection,
            width,
            showSearchOptions,
            showQamusModal,
            isSelectionInAyahBox,
            ayahBox
        }
    },
    mounted() {
        this.scrollActiveAyahToView();
    },
    methods: {
        handleTabChange(isFreshData, tabName) {
            this.clearAllActiveFilter();
            this.handleTabData(isFreshData, tabName);
        },
        scrollActiveAyahToView() {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    const ayah = this.activeAyah;
                    const refName = `ayah${ayah}`
                    const ayahElement = this.$refs[refName]
                    if (ayahElement?.length) {
                        const allSelectedAyah = document.getElementsByClassName('ayahSelected')
                        for (const selectedAyah of allSelectedAyah) {
                            selectedAyah.classList.remove('ayahSelected')
                        }
                        ayahElement[0]?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                        ayahElement[0].classList.add('ayahSelected')
                    }
                })
            })
        },
        async toolDataBottomButtonCliced(hadithGroup, id) {
            const requestParams = {
                ayahNumber: this.activeAyah,
                hadithGroup: hadithGroup,
                language: this.locale,
                surahId: this.activeSurah
            }
            const hadithGroupList = await this.hadithStore.getHadithGroupList(requestParams);
            const objectOfToolData = this.listData.find(object => object.id == id)
            objectOfToolData.button.data = hadithGroupList
        },
        async toolDataLeftButtonCliced(object) {
            this.relatedAyahDocumentsData.isLoading = false;
            this.toggleShowRelatedAyahDocument();

            const requestParams = {
                ayahNumber: this.activeAyah,
                language: this.locale,
                relatedAyahNumber: object.relatedAyahNumber,
                relatedSurahId: object.relatedSurahId,
                surahId: this.activeSurah
            }

            this.isLoading = true;

            const serviceResponse = await this.ayahStore.getRelatedAyahDocuments(requestParams);
            let wantedData;
            switch (object.RelatedTypeId) {
                case 1: //'همنشینی'
                    this.relatedAyahDocumentsData = {
                        data: serviceResponse,
                        type: 2,
                        isLoading: true
                    }
                    break;
                case 3://'لفظی'
                    wantedData = serviceResponse.find(object => (JSON.parse(object.Text) && JSON.parse(object.Text)[0]?.type))
                    this.relatedAyahDocumentsData = {
                        data: JSON.parse(wantedData.Text),
                        type: 3,
                        isLoading: true
                    }
                    break;
                case 4://'موضوعی'
                    wantedData = serviceResponse.find(object => (JSON.parse(object.Text)?.fa || JSON.parse(object.Text)?.ar))
                    this.relatedAyahDocumentsData = {
                        data: {
                            fa: JSON.parse(wantedData.Text).fa?.split(','),
                            ar: JSON.parse(wantedData.Text).ar?.split(',')
                        },
                        type: 1,
                        isLoading: true
                    }
                    break;
                default:
                    // console.log("defult")
                    break;
            }

        },
        async toggleShowRelatedAyahDocument() {
            $('#relatedAyahDocumentModal').modal('show');
        },
        handleIntersect() {
            this.offset += 1
            this.handleTabData(false)
        },
        changeOrder(order) {
            if (Math.abs(this.order) === order && order !== 0)
                this.order = -(this.order)
            else
                this.order = order
            this.handleTabData(true);
        },
        handleFacetOptionClick(facetTitle, optionId) {
            const selectedFacet = this.facetData.find((facet) => facet.title === facetTitle)
            let selectedOption = selectedFacet.options.find((option) => option.id === Number(optionId))
            selectedOption = { ...selectedOption, parentTitle: selectedFacet.title }
            for (let option of selectedFacet.options) {
                if (option.id == optionId) {
                    option.selected = true
                }
            }
            if (selectedFacet.title === 'word') {
                for (let option of selectedFacet.options) {
                    if (option.id != optionId) {
                        option.selected = false
                    }
                }
                this.activeOptionFromFacet = this.activeOptionFromFacet?.filter(activeOption => activeOption.parentTitle !== 'word')
            }
            this.mobileFacetClicked(selectedFacet);
            this.activeOptionFromFacet.push(selectedOption)
            this.handleTabData(true);
        },
        clearAllActiveFilter() {
            this.activeOptionFromFacet = []
            if (this.facetData) {
                for (let facet of this.facetData) {
                    for (let option of facet.options) {
                        if (option.selected) {
                            option.selected = false
                        }
                    }
                }
            }
        },
        resetActiveFilter() {
            this.clearAllActiveFilter();
            this.handleTabData(true);
        },
        deleteSelectedFilter(selectedOption) {
            this.activeOptionFromFacet = this.activeOptionFromFacet.filter(option => (option.id != selectedOption.id || option.parentTitle != selectedOption.parentTitle))
            const selectedFacet = this.facetData.find((facet) => facet.title == selectedOption.parentTitle)
            for (let option of selectedFacet.options) {
                if (option.id == selectedOption.id) {
                    option.selected = false
                }
            }
            this.mobileFacetClicked(selectedFacet);
            this.handleTabData(true);
        },
        handleBookFilter(filter) {
            this.toggleShowBookFilterComponent()
            this.activeOptionFromFacet = this.activeOptionFromFacet.filter(object => object.parentTitle !== 'book')
            filter.map(object => this.activeOptionFromFacet.push(object))
            this.handleTabData(true);
        },
        handleClearFilter() {
            this.activeOptionFromFacet = this.activeOptionFromFacet.filter(object => object.parentTitle !== 'book')
            this.handleTabData(true);
            this.toggleShowBookFilterComponent()
        },
        async toggleShowBookFilterComponent(show = false) {
            //if (!this.showBookFilterComponent) {
            if (this.activeTab === 'translate') {
                const params = {
                    language: this.locale,
                    rincomplete: false
                }
                this.bookFilterData = await this.translateStore.getTranslateList(params)
            } else if (this.activeTab === 'commentary') {
                const params = {
                    language: this.locale,
                }
                this.bookFilterData = await this.commentaryStore.getCommentaryList(params)
            } else if (this.activeTab === 'related_hadith') {
                const params = {
                    language: this.locale,
                }
                this.bookFilterData = await this.hadithStore.getHadithList(params)
            }
            //}

            this.showBookFilterComponent = !this.showBookFilterComponent

            show ? $('#bookFilterModal').modal('show') : {};
        },
        async changeActiveSurah(selectedSurah) {
            this.activeSurah = selectedSurah;
            this.isAyahListLoaded = false
            this.getAyahListOfSurah();
            await this.changeActiveAyah(1)
        },
        async changeActiveAyah(ayah, isTrigger) {
            this.activeAyah = ayah;
            this.scrollActiveAyahToView()
            this.audioSource = ''
            this.playerCurrAyah = this.activeAyah
            this.handleTabData(true);
            this.replaceSlug();

            if (isTrigger)
                this.ayahChangedTrigger(this.activeAyah)

            this.selectedAyahObj = this.AyahListOfSurah?.filter((a, i) => {
                return a.SurahId === parseInt(this.activeSurah) && a.AyahNum === parseInt(this.activeAyah);
            })[0]
            // this.playVoice()
        },
        changeActiveOrthography(orthography) {
            this.activeOrthography = orthography;

            const selectedOrthographyCookie = useCookie('selectedOrthography', {
                default: () => 4, // Default value if the cookie doesn't exist
            });
            selectedOrthographyCookie.value = orthography;

            this.getAyahListOfSurah()
        },
        changeActiveQari(qari) {
            this.activeQari = qari

            const selectedRecitorCookie = useCookie('selectedRecitor', {
                default: () => 9, // Default value if the cookie doesn't exist
            });
            selectedRecitorCookie.value = qari;
        },
        async getAudioSource() {
            const params = {
                recitorId: this.activeQari,
                surahId: this.activeSurah
            }
            const voiceList = await this.quranStore.getVoiceList(params)
            const audioObject = voiceList.find(ayah => ayah.AyahNumber === Number(this.activeAyah))
            this.audioSource = `${config.SOUND_BASE_URL}${audioObject.FileUrl}`
        },
        async endAudioEvent() {
            if (this.audioSource.length > 0)
                this.playerCurrAyah++;

            this.changeActiveAyah(this.playerCurrAyah)

            const params = {
                recitorId: this.activeQari,
                surahId: this.activeSurah
            }
            const voiceList = await this.quranStore.getVoiceList(params)
            const audioObject = voiceList.find(ayah => ayah.AyahNumber === Number(this.playerCurrAyah))
            this.audioSource = `${config.SOUND_BASE_URL}${audioObject.FileUrl}`
        },
        toggleFullScreen() {
            const ayahContainerElement = document.querySelector(".tazhib");//document.getElementById("ayahContainer");
            if (this.isAyahContaienrFullScreen) {
                ayahContainerElement.style.height = 250 + "px"
                this.isAyahContaienrFullScreen = false
            } else {
                const toolTabsElement = document.getElementById("tab-cnt");
                const spaceFromBottom = window.innerHeight - ayahContainerElement.offsetTop - ayahContainerElement.offsetHeight - toolTabsElement.offsetHeight;
                ayahContainerElement.style.height = ayahContainerElement.offsetHeight + spaceFromBottom + "px";
                this.isAyahContaienrFullScreen = true
            }

        },
        mobileFacetClicked(facet) {
            this.facetDataForMobile = this.facetData.find(item => item.title === facet.title);
        },
        closeFacet() {
            this.facetDataForMobile = {}
        },
        loadMoreCommentary(item) {
            const params = {
                id: item.id,
                item: item,
                language: this.locale,
            }

            this.getCommentarySingle(params);
        }
    },
}